/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.graph.block'

export { $nsid }

/** Record declaring a 'block' relationship against another account. NOTE: blocks are public in Bluesky; see blog posts for details. */
type Main = {
  $type: 'app.bsky.graph.block'

  /**
   * DID of the account to be blocked.
   */
  subject: l.DidString
  createdAt: l.DatetimeString
}

export type { Main }

/** Record declaring a 'block' relationship against another account. NOTE: blocks are public in Bluesky; see blog posts for details. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    subject: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
